const CHECKED_SELECTION_IDS = 'CHECKED_SELECTION_IDS';
const LIVE_SELECTION_IDS = 'LIVE_SELECTION_IDS';

const ls = window.localStorage;

export const persist = (lsKey, arr) => ls.setItem(lsKey, JSON.stringify(arr));

export const lsStore = lsKey => {
  const store = ls.getItem(lsKey) || '';

  let ids = store ? JSON.parse(store) : [];

  return ids;
};

export const set = (lsKey, id) => {
  let ids = lsStore(lsKey);

  const foundIndex = ids.findIndex(a => a === id);

  if (foundIndex == -1) {
    ids = [...ids, id];
  }

  persist(lsKey, ids);
};

export const remove = (lsKey, id) => {
  let ids = lsStore(lsKey);

  const foundIndex = ids.findIndex(a => a === id);

  if (foundIndex > -1) {
    ids = [...ids.slice(0, foundIndex), ...ids.slice(foundIndex + 1)];
  }
  persist(lsKey, ids);
};

export const isExist = (lsKey, id) => {
  return lsStore(lsKey).findIndex(a => a === id) > -1;
};

export const persistCheckedIds = arr => persist(CHECKED_SELECTION_IDS, arr);
export const checkedSelectionStore = () => lsStore(CHECKED_SELECTION_IDS);
export const isChecked = id => isExist(CHECKED_SELECTION_IDS, id);
export const setChecked = id => set(CHECKED_SELECTION_IDS, id);

export const persistLiveIds = arr => persist(LIVE_SELECTION_IDS, arr);
export const liveSelectionStore = () => lsStore(LIVE_SELECTION_IDS);
export const isLive = id => isExist(LIVE_SELECTION_IDS, id);
export const setLive = id => set(LIVE_SELECTION_IDS, id);
export const removeLive = id => remove(LIVE_SELECTION_IDS, id);
